import React from 'react';
import { CheckIcon } from 'lucide-react';
import { QuoteForm } from './QuoteForm';
export const ReviewsSection = () => {
  const reviews = [{
    id: 1,
    name: 'Jan de Vries',
    company: 'Eigenaar Zeilboot "Zeemeeuw"',
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    headline: 'Perfecte transformatie van onze boot',
    text: 'Zeer professioneel en betrouwbaar. Marco Leer heeft onze boot compleet getransformeerd. De kwaliteit van het materiaal en het vakmanschap zijn echt uitmuntend.',
    rating: 5
  }, {
    id: 2,
    name: 'Lisa Jansen',
    company: 'Eigenaar Sloep "Waterlelie"',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    headline: 'Een professionele en betrokken partner!',
    text: 'Binnen een week een perfect resultaat. De kwaliteit van het werk is uitstekend en Marco denkt echt met je mee. Ze overtreffen altijd de verwachtingen.',
    rating: 5
  }, {
    id: 3,
    name: 'Peter Bakker',
    company: 'Eigenaar Jacht "Zeehond"',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    headline: 'Vakmanschap van het hoogste niveau',
    text: 'Fantastisch advies gekregen over de juiste materialen. Het resultaat is prachtig en de stoffering is na twee jaar nog steeds als nieuw, ondanks intensief gebruik.',
    rating: 5
  }];
  return <section className="py-20 bg-[#F5F5F7]" data-id="element-151">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-152">
        <div className="text-center mb-16" data-id="element-153">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-154">
            "Onze klanten zijn niet alleen tevreden"
          </h2>
          <p className="text-xl text-gray-500" data-id="element-155">
            Ze hebben{' '}
            <span className="text-gray-700 font-medium" data-id="element-156">nog nooit</span> iets
            van dit kaliber ervaren.
          </p>
        </div>
        <div className="space-y-6" data-id="element-157">
          {reviews.map(review => <div key={review.id} className="bg-white p-8 rounded-lg" data-id="element-158">
              <div className="flex items-center mb-4" data-id="element-159">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-160">
                  <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <h3 className="font-semibold text-lg" data-id="element-163">{review.name}</h3>
                  <p className="text-gray-500 text-sm" data-id="element-164">{review.company}</p>
                </div>
              </div>
              <div className="flex items-center mb-6" data-id="element-165">
                <div className="flex mr-3" data-id="element-166">
                  {[...Array(review.rating)].map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 24 24" data-id="element-167">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-168" />
                    </svg>)}
                </div>
                <div className="flex items-center text-gray-400 text-sm" data-id="element-169">
                  <span className="bg-gray-100 rounded-full p-1 mr-1" data-id="element-170">
                    <CheckIcon className="w-3 h-3 text-gray-500" data-id="element-171" />
                  </span>
                  Geverifieerd
                </div>
              </div>
              <h4 className="text-2xl font-bold mb-3" data-id="element-172">{review.headline}</h4>
              <p className="text-gray-600" data-id="element-173">{review.text}</p>
            </div>)}
        </div>
      </div>
      <div className="mt-20 bg-white py-16" data-id="element-174">
        <div className="container mx-auto px-4" data-id="element-175">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-176">
            Vraag direct een vrijblijvende offerte aan
          </h3>
          <div className="max-w-md mx-auto" data-id="element-177">
            <QuoteForm data-id="element-178" />
          </div>
        </div>
      </div>
    </section>;
};